export const GET_FLEET_TRIP = "GET_FLEET_TRIP";
export const GET_FLEET_TRIP_SUCCESS = "GET_FLEET_TRIP_SUCCESS";
export const GET_FLEET_TRIP_FAILURE="GET_FLEET_TRIP_SUCCESS";
export const GET_DEVICE_USER_MAPPING="GET_DEVICE_USER_MAPPING";
export const GET_DEVICE_USER_MAPPING_SUCCESS="GET_DEVICE_USER_MAPPING_SUCCESS";
export const GET_DEVICE_USER_MAPPING_FAILURE="GET_DEVICE_USER_MAPPING_FAILURE";
export const GET_DEVICE_USERS="GET_DEVICE_USERS";
export const GET_DEVICE_USERS_SUCCESS="GET_DEVICE_USERS_SUCCESS";
export const GET_DEVICE_USERS_FAILURE="GET_DEVICE_USERS_FAILURE";
export const STORE_STOMP_CLIENT="STORE_STOMP_CLIENT";